import {defineAsyncComponent} from 'vue'
const NotificationRouter = [
  // 消息列表
  {
    path: 'notification',
    name: 'Notification',
    component: () => import('@/views/Notification/Notification/Index.vue'),
    meta: {
      key: 'notification'
    },
  },
  // 通知发布
  {
    path: 'op_notification',
    name: 'OpNotification',
    component: () => import('@/views/Notification/OpNotification/Index.vue'),
    meta: {
      key: 'notification'
    },
  },
]
export {NotificationRouter}
